// extracted by mini-css-extract-plugin
export default {"btn":"GrayBtn_btn__SKQpa"};